/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ResponseGetWarehouseResponse,
} from '../models/index';
import {
    ResponseGetWarehouseResponseFromJSON,
    ResponseGetWarehouseResponseToJSON,
} from '../models/index';

/**
 * 
 */
export class WarehousesApi extends runtime.BaseAPI {

    /**
     * 倉庫一覧を取得
     * 倉庫一覧を取得
     */
    async warehousesGetAllGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ResponseGetWarehouseResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/warehouses/getAll`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ResponseGetWarehouseResponseFromJSON));
    }

    /**
     * 倉庫一覧を取得
     * 倉庫一覧を取得
     */
    async warehousesGetAllGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ResponseGetWarehouseResponse>> {
        const response = await this.warehousesGetAllGetRaw(initOverrides);
        return await response.value();
    }

}
